import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-master-action-renderer',
    templateUrl: './master-action-renderer.component.html',
    styleUrls: ['./master-action-renderer.component.scss'],
    standalone: false // NOSONAR
})
export class MasterActionRendererComponent {
  //implements OnInit {
  @Input() name: string;
  public params: any;
  hidden: boolean = false;
  resetHidden: boolean = false;

  constructor(  private readonly dialog : MatDialog) {}

  agInit(params: any): void {
    this.params = params;
    if (this.params.data == undefined) { // NOSONAR
      this.hidden = true;
    } else {
      this.evaluateHidden();
    }
  }

  evaluateHidden() {
    if (!this.params.data.updated) {
      this.resetHidden = true;
    }
  }

  updateMasterSettings(event: MouseEvent) {
    event.stopPropagation();
    this.params?.context.componentParent.buttonActionUpdate(this.params.data);
  }

  refreshMasterSettings(event: MouseEvent) {
    event.stopPropagation();
    this.params?.context.componentParent.buttonActionRefresh(this.params.data);
  }

  deleteMasterSettings(event: MouseEvent) {
    event.stopPropagation();
    this.params?.context.componentParent.buttonActionDelete(this.params.data);
  }

  // ngOnInit(): void {
  // }
}
